import Axios, {AxiosRequestConfig, AxiosResponse, CancelTokenSource} from "axios";
import {CancellationToken} from "./WPAjaxPost";
import {ToastService} from "../services/ToastService";
declare let ajaxurl:string;

export class RequestHandler<T>{th
    public headers:any=undefined;
    private cancelSource: CancelTokenSource=null;
    public data:FormData|any;
    public url:string;
    constructor(action:string, data:any,url:string,private options:RequestOptions,files?:any)
    {
        if(this.options==null)
            this.options={};

        this.SetDefaultValue("OnError", null);
        this.SetDefaultValue("ReturnError", false);

        if((window as any).RNGlobalVar!=null) {
            if(typeof ((window as any).RNGlobalVar)._nonce !='undefined')
                this.SetDefaultValue('Nonce', ((window as any).RNGlobalVar)._nonce);

            if(typeof ((window as any).RNGlobalVar)._prefix!='undefined')
                this.SetDefaultValue('Prefix',((window as any).RNGlobalVar)._prefix)
        }



        this.url=url;
        if(action!='')
        {
            this.data=new FormData();
            this.data.append('action',action);
            this.data.append('data',JSON.stringify(data));

            if(files!=null)
                for(let property in files)
                {
                    this.data.append(property,files[property]);
                }
        }else{
            this.data=data;
        }



    }

    public setHeaders(headers:any){
        this.headers=headers;
        return this;
    }

    private setCancelToken(cancelToken:CancellationToken)
    {
        this.cancelSource=cancelToken.source;
        return this;
    }


    private SetDefaultValue(propertyName:keyof RequestOptions,value)
    {
        if(typeof  this.options[propertyName]=="undefined")
            this.options[propertyName]=value;

    }




    public setHandleSendError(callback:(errorMessage:string)=>void){
        this.options.OnError=callback;
        return this;
    }

    public Execute():Promise<T>{
            let config:AxiosRequestConfig={};
            if(this.cancelSource!=null)
                config.cancelToken=this.cancelSource.token;

            if(typeof this.headers!="undefined")
                config.headers=this.headers;

            if(this.options.Nonce!=null)
                this.data.append('_nonce',this.options.Nonce);

            if(this.options.Prefix!=null)
                this.data.set('action',this.options.Prefix+'_'+this.data.get('action'));

            return Axios.post<{success:boolean,result:T,errorMessage:string}>(this.url,this.data,config)
                .then((result:AxiosResponse<{success:boolean,result:T,errorMessage:string,mappings:any[]}>)=>{
                    if(result.status!=200)
                    {
                        ToastService.SendErrorMessage('An unexpected error occurred, please try again');
                        return null;

                    }else if(!result.data.success)
                    {
                        if(this.options.OnError!=null)
                        {
                            this.options.OnError(result.data.errorMessage);
                            return null;

                        }


                        if(this.options.ReturnError)
                        {
                            return {success:false,result:null,errorMessage:result.data.errorMessage};
                        }else
                            ToastService.SendErrorMessage(result.data.errorMessage);

                        return null;
                    }else
                    {
                        let returnData=result.data.result;
                        if(typeof result.data.mappings!="undefined")
                            returnData=this.SerializeResult(result.data.result,result.data.mappings);
                        return returnData;
                    }
                }).catch((er:any)=>{
                    if(Axios.isCancel(er)&&this.cancelSource!=null)
                        return er;

                    ToastService.SendErrorMessage('An unexpected error occurred, please try again');
                    return null;
                });

    }

    public ExecuteWithCancellation(cancellationToken:CancellationToken){
        this.setCancelToken(cancellationToken);
        return this.Execute().then((result)=>{
            if(result==null)
                return null;
            if(Axios.isCancel(result))
                return {
                    wasCancelled:true,
                    result:null
                };
            else
                return {
                    wasCancelled:false,
                    result:result
                };

        });

    }


    private SerializeResult(result: T, mappings: any[]) {
        if(result instanceof Array) {
            for (let i = 0; i < result.length; i++) {
                result[i] = this.SerializeItem(result[i], mappings);
            }
            return result;
        }
        else
            return this.SerializeItem(result,mappings);


    }

    private SerializeItem(object: T, mappings: any[]) {
        if(object==null)
            return object;
        for(let property in mappings)
        {

            switch(mappings[property])
            {
                case 'json':
                    if(typeof object[property]!='undefined')
                        object[property]=JSON.parse(object[property]);
                    break;
            }
        }

        return object;
    }
}


export interface RequestOptions{
    OnError?:(errorMessage:string)=>void;
    ReturnError?:boolean;
    Nonce?:string;
    Prefix?:string;
}
